var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-card.ts
import "@adornis/base/utilTypes.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ChemistryLitElement } from "../../chemistry-lit-element.js";
import { css } from "../../directives/css.js";
import { injectAttributesOf } from "../../directives/inject-attributes.js";
import { xComponents } from "../x-components.js";
import { XFlex } from "./x-flex.js";
import "./x-hr.js";
import "./x-icon.js";
import "./x-link.js";
var shadow = "0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5";
var raisedShadow = "0 0 0 1px #d4d4d5, 0 2px 4px 0 rgba(34,36,38,.12), 0 2px 10px 0 rgba(34,36,38,.15)";
var hoverShadow = "0 1px 3px 0 #bcbdbd, 0 0 0 1px #d4d4d5";
var hoverStyle = { transform: "translateY(-2px)", boxShadow: `var(--shadow-lg, ${hoverShadow})` };
var XBasicCard = class extends XFlex {
  styles() {
    return [
      ...super.styles(),
      {
        display: "flex",
        borderRadius: this.sizes.borderRadius,
        boxShadow: `var(--shadow-md, ${shadow})`,
        overflow: "hidden",
        background: `var(--color-base-100, ${this.colors.white})`,
        "&[raised]": { boxShadow: `var(--shadow-xl, ${raisedShadow})` },
        "&:hover": { "&[href]": hoverStyle },
        "@media print": {
          boxShadow: "none",
          border: `1px solid var(--color-base-300, ${this.colors.neutral.shade(200)})`
        }
      }
    ];
  }
};
XBasicCard = __decorateClass([
  customElement("x-basic-card")
], XBasicCard);
var XCard = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.padding = "md";
    this.space = "md";
    this.hover = false;
  }
  styles() {
    return [
      {
        ":host": {
          display: "flex",
          boxSizing: "border-box",
          background: `var(--color-base-100, ${this.colors.white})`,
          transition: "box-shadow .1s ease, transform .1s ease",
          width: "fit-content"
        },
        ":host([no-elevation])": { boxShadow: "none" },
        ":host([popout]), :host([no-padding])": {
          padding: "0"
        },
        ...Object.fromEntries(
          Object.entries(this.colors.tone).map(([tone, color]) => [
            `:host([tone=${tone}])`,
            {
              background: `var(--color-${tone}, ${color})`,
              color: `var(--color-${tone}-content, ${this.colors.on.tone[tone]})`
            }
          ])
        ),
        [`:host(${this.hover ? "" : "[href]"}:hover)`]: { transform: "translateY(-3px)" },
        '::slotted([slot="extra"])': { padding: this.spacing.md }
      }
    ];
  }
  // default
  render() {
    const card = xComponents(html` <x-basic-card ${css({ width: "100%" })}> ${this.content()} </x-basic-card> `);
    if (this.href)
      return xComponents(html` <x-link ${css({ width: "100%" })} href=${this.href}> ${card} </x-link> `);
    return card;
  }
  content() {
    return xComponents(html`
      <x-flex flex>
        <slot name="image"></slot>
        <x-flex flex ${injectAttributesOf(this)}>
          <slot></slot>
        </x-flex>
        <x-hr></x-hr>
        <slot name="extra"></slot>
      </x-flex>
    `);
  }
};
__decorateClass([
  property({ reflect: true })
], XCard.prototype, "href", 2);
__decorateClass([
  property({ reflect: true })
], XCard.prototype, "padding", 2);
__decorateClass([
  property({ reflect: true })
], XCard.prototype, "space", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], XCard.prototype, "hover", 2);
XCard = __decorateClass([
  customElement("x-card")
], XCard);
export {
  XBasicCard,
  XCard
};
